/**
 * Base 타입 및 상수 정의
 * @packageDocumentation
 */ // 화면 압축 모드 타입
// 브레이크포인트 상수
export var BREAKPOINTS = {
    mobile: 640,
    tablet: 768,
    desktop: 1024,
    wide: 1280
};
// 미디어 쿼리 헬퍼
export var MEDIA_QUERIES = {
    mobile: "@media (max-width: ".concat(BREAKPOINTS.mobile - 1, "px)"),
    tablet: "@media (min-width: ".concat(BREAKPOINTS.mobile, "px) and (max-width: ").concat(BREAKPOINTS.tablet - 1, "px)"),
    desktop: "@media (min-width: ".concat(BREAKPOINTS.tablet, "px)"),
    wide: "@media (min-width: ".concat(BREAKPOINTS.wide, "px)")
};
// 페이지네이션 상수
export var PAGE_SIZE = 20;
